<div class="signup__tier" [ngClass]="{ 'signup__tier--highlight': highlighted }">
  <div class="signup__tier-title">{{ title }}
    @if (selected) {
    <span> Selected</span>
    }
  </div>
  <div class="signup__tier-price">${{ monthlyPrice }}<span>/mo<sup>*</sup></span></div>

  @if (planType == 'PeerComparisonStandard') {
  <div class="signup__tier-discount"> &nbsp;&nbsp;Context That Clarifies, Benchmarks That Matter</div>
  }
  @if (planType == 'BundleYearly')
  {
  <div class="signup__tier-discount"> &nbsp;&nbsp;Better Together: Smarter Insights, Stronger ALM</div>
  }
  @if (planType == 'NonMaturityDepositsStandard')
  {
  <div class="signup__tier-discount"> &nbsp;&nbsp;Strong models built with clarity, not complexity</div>
  }
  <ul class="signup__tier-features">
    @for (feature of featureEntries; track feature) {
    <li>
      <svg class="icon signup__tier-features-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <path
          d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" />
      </svg> {{ feature[0] }}
    </li>
    <ul>
      @for (child of feature[1]; track child) {
      <li>⦁ {{ child }}</li>
      }
    </ul>
    }
    @if (planType == 'PeerComparisonStandard'){
    <li class="billing-note"><em>* Monthly/Annual</em></li>

    }
    @else{
    <li class="billing-note"><em>* Billed Annually</em></li>
    }
  </ul>



  @if (!selected) {
  @if (!upgrade) {
  <div class="signup__tier-button-wrap">
    <a class="signup__tier-button button" routerLink="/signup" [queryParams]="{ plan: planType }">Select Plan</a>
  </div>
  } @else {
  @if (highlighted) {
  <div class="signup__tier-button-wrap">
    <a class="signup__tier-button button" routerLink="/upgrade" [queryParams]="{ plan: planType }">Upgrade Now</a>
  </div>
  } @else {
  <div class="signup__tier-button-wrap">
    Your Current Plan
  </div>
  }
  }
  }
  @else {
  @if (!upgrade) {
  <a class="signup__more" routerLink="/pricing"><svg class="icon signup__more-icon" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512">
      <path
        d="M77.25 256l137.4-137.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25l160 160C175.6 444.9 183.8 448 192 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L77.25 256zM269.3 256l137.4-137.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25l160 160C367.6 444.9 375.8 448 384 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L269.3 256z" />
    </svg> Change Plan</a>
  }
  }
</div>